/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorksCouncilTypeDto = {
    Betriebsrat: 'BETRIEBSRAT',
    Gesamtbetriebsrat: 'GESAMTBETRIEBSRAT',
    Konzernbetriebsrat: 'KONZERNBETRIEBSRAT'
} as const;
export type WorksCouncilTypeDto = typeof WorksCouncilTypeDto[keyof typeof WorksCouncilTypeDto];


export function instanceOfWorksCouncilTypeDto(value: any): boolean {
    for (const key in WorksCouncilTypeDto) {
        if (Object.prototype.hasOwnProperty.call(WorksCouncilTypeDto, key)) {
            if (WorksCouncilTypeDto[key as keyof typeof WorksCouncilTypeDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorksCouncilTypeDtoFromJSON(json: any): WorksCouncilTypeDto {
    return WorksCouncilTypeDtoFromJSONTyped(json, false);
}

export function WorksCouncilTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorksCouncilTypeDto {
    return json as WorksCouncilTypeDto;
}

export function WorksCouncilTypeDtoToJSON(value?: WorksCouncilTypeDto | null): any {
    return value as any;
}

export function WorksCouncilTypeDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): WorksCouncilTypeDto {
    return value as WorksCouncilTypeDto;
}

